/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wsc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It replaces any run of spaces or tabs inside a line with a single space, so 'a    b' becomes 'a b'. Line breaks are kept.`)
};

const es_wsc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reemplaza cualquier secuencia de espacios o tabulaciones dentro de una línea con un solo espacio, por lo que 'a    b' se convierte en 'a b'. Los saltos de línea se conservan.`)
};

const de_wsc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es ersetzt jede Folge von Leerzeichen oder Tabulatoren innerhalb einer Zeile durch ein einzelnes Leerzeichen, sodass aus 'a    b' 'a b' wird. Zeilenumbrüche bleiben erhalten.`)
};

const nl_wsc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het vervangt elke reeks spaties of tabs in een regel door één spatie, dus 'a    b' wordt 'a b'. Regeleinden blijven behouden.`)
};

const fr_wsc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elle remplace toute suite d'espaces ou de tabulations à l'intérieur d'une ligne par un seul espace, de sorte que « a    b » devient « a b ». Les sauts de ligne sont conservés.`)
};

const it_wsc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sostituisce qualsiasi sequenza di spazi o tabulazioni all'interno di una riga con un singolo spazio, quindi 'a    b' diventa 'a b'. I segni di interruzione di riga vengono mantenuti.`)
};

const pt_br2_wsc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substitui qualquer sequência de espaços ou abas dentro de uma linha por um único espaço, portanto 'a    b' se torna 'a b'. Quebras de linha são mantidas.`)
};

const pt_wsc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substitui qualquer sequência de espaços ou abas dentro de uma linha por um único espaço, portanto "a    b" fica "a b". As quebras de linha são mantidas.`)
};

const ja_wsc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`それは行内のスペースまたはタブの連続を単一のスペースに置き換えるため、a    bはa bになります。改行は保持されます。`)
};

const zh_wsc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它会将一行内连续的空格或制表符替换为单个空格，所以 “a    b” 会变成 “a b”。换行符会被保留。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wsc_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wsc_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wsc_faq1_a", locale)
	if (locale === "en") return en_wsc_faq1_a(inputs)
	if (locale === "es") return es_wsc_faq1_a(inputs)
	if (locale === "de") return de_wsc_faq1_a(inputs)
	if (locale === "nl") return nl_wsc_faq1_a(inputs)
	if (locale === "fr") return fr_wsc_faq1_a(inputs)
	if (locale === "it") return it_wsc_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_wsc_faq1_a(inputs)
	if (locale === "pt") return pt_wsc_faq1_a(inputs)
	if (locale === "ja") return ja_wsc_faq1_a(inputs)
	return zh_wsc_faq1_a(inputs)
};